/**
* 单页面汇总
*/
<template>
	<div class="container">
		
		
		<div class="vip-item">
			<span class="vip-text">VIP兑换地址</span>
			<a :href="url_VipExchange" class="vip-link" target="_blank">{{ url_VipExchange }}</a>
		</div>
		
		
		<div class="vip-item">
			<span class="vip-text">支持4G卡的国家地址</span>
			<a :href="url_gen3Country" class="vip-link" target="_blank">{{ url_gen3Country }}</a>
		</div>
		
		
		<div class="vip-item">
			<span class="vip-text">APP隐私政策地址</span>
			<a :href="url_QIUIPrivacyPolicy" class="vip-link" target="_blank">{{ url_QIUIPrivacyPolicy }}</a>
		</div>
		
		
		<div class="vip-item">
			<span class="vip-text">Stripe充值地址</span>
			<a :href="url_QIUI_Stripe" class="vip-link" target="_blank">{{ url_QIUI_Stripe }}</a>
		</div>
		
		<div class="vip-item">
			<span class="vip-text">Stripe开发者平台</span>
			<a :href="url_QIUI_Top_Up" class="vip-link" target="_blank">{{ url_QIUI_Top_Up }}</a>
		</div>
		
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				url_VipExchange: this.$p_domainName + '/VipExchange',
				url_gen3Country: this.$p_domainName + '/gen3Country',
				url_QIUIPrivacyPolicy: this.$p_domainName + '/QIUIPrivacyPolicy',
				url_QIUI_Stripe: this.$p_domainName + '/StripeLogin',
				url_QIUI_Top_Up: this.$p_domainName + '/DevelopersLogin',
			};
		}
	}
</script>

<style scoped>
	.container {
		display: flex;
		flex-direction: column;
		height: 89vh;
		padding: 20px;
		box-sizing: border-box;
	}

	.vip-item {
		display: flex;
		flex-direction: column;
		margin-bottom: 16px;
	}

	.vip-text {
		font-size: 18px;
		font-weight: 600;
		color: #333;
		margin-bottom: 8px;
	}

	.vip-link {
		font-size: 16px;
		color: #007bff;
		text-decoration: none;
		border-bottom: 1px solid #007bff;
		transition: color 0.3s, border-bottom 0.3s;
	}

	.vip-link:hover {
		color: #0056b3;
		border-bottom: 1px solid #0056b3;
	}

	/* Responsive design */
	@media (max-width: 600px) {

		.vip-text,
		.vip-link {
			font-size: 14px;
		}

		.container {
			padding: 10px;
		}

		.vip-item {
			margin-bottom: 12px;
		}
	}
</style>